const getAcceptList = (extensions: string[]) => {
  return extensions.map((e) => `.${e}`).join()
}

export default getAcceptList
